import React, { FunctionComponent } from "react";
import NewsSpotlight from "src/news/components/Spotlight/NewsSpotlight";

const SpotlightNewsWrapper: FunctionComponent = () => (
    <NewsSpotlight />
);

export default SpotlightNewsWrapper;
